import React from 'react';

import { DialogProps } from '../../types';
import VersionHistoryDialog from './VersionHistoryDialog';

const VersionHistory: React.FC<DialogProps> = ({ content, onClose }) => {
  return <VersionHistoryDialog contentId={content.id} onClose={onClose} />;
};

export default VersionHistory;
